import React, { lazy } from 'react';
import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';
import privateRouterRoutes from './subrouters/private/routes';
import NotFoundPage from './pages/NotFoundPage';
import { Navigate } from 'react-router-dom';
import { businessesRoutes } from './subrouters/Business';
import ContactUs from './pages/ContactUs';
import { Search } from './pages/Search';
import { urgentCampaignsRoutes } from './subrouters/UrgentCampaigns';

const PrivateRouter = lazy(() => import('./subrouters/private'));
const BusinessRouter = lazy(() => import('./subrouters/Business'));
const UrgentCampaignsRouter = lazy(
  () => import('./subrouters/UrgentCampaigns'),
);

export default [
  {
    path: 'business',
    element: <BusinessRouter />,
    routes: businessesRoutes,
  },
  {
    path: 'urgent',
    element: <UrgentCampaignsRouter />,
    routes: urgentCampaignsRoutes,
  },
  {
    path: 'dash',
    element: <PrivateRouter />,
    authorized: true,
    routes: privateRouterRoutes,
  },
  {
    path: 'contact-us',
    element: ContactUs,
  },
  {
    path: 'search',
    element: Search,
  },
  { index: true, element: <Navigate to="business" replace /> },
  { path: '*', element: NotFoundPage },
] as Array<EnhancedRouteProps>;
